import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./icon-button-v2.css";

export interface IconButtonV2Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  size?: "small" | "normal" | "large";
  variant?: "neutral" | "contrast" | "ghost" | "ghost-muted";
  state?: "rest" | "hover" | "pressed";
  children?: ReactNode;
}

export function IconButtonV2({
  size = "normal",
  variant = "neutral",
  state,
  icon,
  className,
  children,
  ...props
}: IconButtonV2Props) {
  return (
    <button
      {...props}
      data-component="icon-button-v2"
      data-size={size}
      data-variant={variant}
      data-state={state}
      className={className}
    >
      {icon}
      {children}
    </button>
  );
}
